<template>
  <div class="modal-content fm-modal-audio-player">
    <div class="modal-header">
      <h5 class="modal-title w-75 text-truncate">
        {{ data.filename }}
        <small class="text-muted pl-3"></small>
      </h5>
      <button type="button" aria-label="Close" @click="hideModal">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <audio ref="modalAudio" crossorigin controls>
        <source :src="data.url" type="audio/mp3" />
      </audio>

      <div class="mt-4 mb-2">
        برای ساخت برنامه‌ از فایل از مسیر زیر استفاده کنید.
      </div>

      <div class="input-group">
        <div class="input-group-prepend">
          <button
            class="btn btn-secondary"
            type="button"
            @click="copyText(data.path, $event)"
          >
            <i class="far fa-1x fa-copy align-baseline"></i>
          </button>
        </div>
        <input
          type="text"
          class="form-control"
          dir="ltr"
          :value="data.path"
          readonly
        />
      </div>
    </div>

    <div class="d-flex justify-content-end">
      <span class="d-block">
        <a
          class="btn btn-sm btn-primary"
          :href="data.url"
          target="_blank"
          :download="data.basename"
        >
          دانلود
        </a>
      </span>
    </div>
  </div>
</template>

<style lang="scss">
@import "~plyr/src/sass/plyr.scss";

.fm-modal-audio-player {
  & > .d-flex {
    padding: 1rem;
    border-top: 1px solid #e9ecef;
  }
}
</style>

<script>
import Plyr from 'plyr/dist/plyr.polyfilled.js'
export default {
  name: "Player",
  data() {
    return {
      player: {},
      status: "paused"
    };
  },
  props: {
    data: Object
  },
  mounted() {
    this.player = new Plyr(this.$refs.modalAudio, {
      type: "audio",
      speed: {
        selected: 1,
        options: [0.5, 1, 1.5]
      }
    });
  },
  beforeDestroy() {
    this.player.destroy();
  }
};
</script>
